__webpack_require__.p = "https://www.allstar.gg/";